import { BaseTableEditorStore } from '@/tableDefinitionEditor/baseTableEditorStore';
import type { BaseTableEditorDehydratedStoreState } from '@/tableDefinitionEditor/baseTableEditorStore';

export type ItemTableEditorDehydratedState = BaseTableEditorDehydratedStoreState;

export class ItemTableEditorStore extends BaseTableEditorStore {
  static readonly storeName = 'sqItemTableEditorStore';

  override initialize() {
    super.initialize();
  }

  override dehydrate(): ItemTableEditorDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ItemTableEditorDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  override handlers = {
    ITEM_SET_TABLE_ID: this.setTableId,
    ITEM_RESET_TABLE_EDITOR_STORE: this.reset,
    ITEM_SET_SHOW_CONFIGURE_SEARCH: this.setShowConfigureSearch,
    ITEM_SET_ENABLE_TREE_CREATION: this.setEnableTreeCreation,
    ITEM_SET_COLUMN_TO_EDIT_ID: this.setColumnToEditId,
    ITEM_SET_SHOW_COLUMN_PROPERTIES: this.setShowColumnProperties,
    ITEM_SET_SELECTED_COLUMN_OPTION: this.setSelectedColumnOption,
    ITEM_SET_SHORTCUT_SOURCE_COLUMN_ID: this.setShortcutSourceColumnId,
    ITEM_SET_CONTROL_PANE: this.setControlPane,
    ITEM_SET_INITIAL_COLUMN_RULE: this.setInitialColumnRule,
    ITEM_SET_INITIAL_RULE_PARAMETER_OVERRIDES: this.setInitialRuleParameterOverrides,
    ITEM_SET_AUTO_OPEN_COLUMN_RULE: this.setAutoOpenColumnRule,
    ITEM_SET_STORED_TABLE_SEARCH_WARNING_DISMISSED: this.setStoredTableSearchWarningDismissed,
  };
}
